import { Mesh, PlaneGeometry, ShaderMaterial, use } from '@anov/3d-core'
import fogShader from '../../shaders/fog'
import type { IFogOption } from '../../utils/constant'

const _defaultOption: IFogOption = {
  fogcolor: [0.9, 0.9, 0.9],
  alpha: 0.5,
  speed: 0.01,
}

class Fog2DMesh extends Mesh {
  option: IFogOption = _defaultOption
  uniforms: any

  constructor(ops?: IFogOption) {
    super()
    this.geometry = new PlaneGeometry(10, 10)

    Object.assign(this.option, ops)
    this.setUniforms({ ...this.option, iTime: 0 })

    this.material = new ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: fogShader.vertexShader,
      fragmentShader: fogShader.fragmentShader,
      side: 2,
      blending: 2,
      transparent: true,
      depthWrite: false,
    })
    this.renderOrder = 1
  }

  private setUniforms(option: IFogOption) {
    if (!this.uniforms)
      this.uniforms = {}

    Object.assign(this.option, option)

    Object.keys(option).forEach((key: string) => {
      this.uniforms[key] = { value: option[key] }
    })
  }

  setColor(color: number[]) {
    this.setUniforms({ fogcolor: color })
  }

  setAlpha(alpha: number) {
    this.setUniforms({ alpha })
  }

  setSpeed(speed: number) {
    this.setUniforms({ speed })
  }

  update() {
    const { speed = 0.01 } = this.option
    const { iTime } = this.uniforms
    iTime.value += speed
  }

  delete() {
    this.remove()
    this.removeFromParent()
  }
}

export default Fog2DMesh